import { div } from "lqx-react";

export const VerticalContainer = div({
    background: '#FFFFFF',
    paddingTop: '30px',
    marginBottom: '50px'
});

export const BuyerEditTitle = div({
    ontFamily: 'Montserrat',
    color: '#4197d6',
    fontWeight: 600,
    fontStyle: 'normal',
    fontSize: '16px',
    lineHeight: '20px',
    marginBottom: '15px',
    paddingLeft: '15px'
});

export const BuyersLabel = div({
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '15px',
    color: '#8695A4',
    padding: '5px'
});
